/** @jsxImportSource @emotion/react */
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { getCollection, getTotalCount, useCampaigns } from "../../hooks/useCampaignQueries";
import CampaignsPanel from "./components/CampaignsPanel";
import pageStyles from "./pageStyles";
import Footer1 from "../../components/Footer/Footer";

const Campaigns = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useContext(UserContext);
  // City the user was browsing on Home. Undefined on a direct visit or a
  // refresh, in which case the backend falls back to their profile city.
  const selCity = location?.state?.selCity;
  const { data, isLoading, isError } = useCampaigns({
    token: userDetails?.token,
    city: selCity,
  });
  const campaigns = getCollection(data);

  return (
    <div css={pageStyles.route}>
      <main css={pageStyles.page}>
        <div css={pageStyles.container}>
          <header css={[pageStyles.header, pageStyles.listingHeader]}>
            <div css={pageStyles.listingHeaderCopy}>
              <p css={pageStyles.eyebrow}>Campaigns</p>
              <h1 css={pageStyles.title}>All ongoing campaigns</h1>
              <p css={pageStyles.subtitle}>
                Browse active campaigns, book tickets, and complete payment before the window closes.
              </p>
            </div>
            <Button
              css={[pageStyles.backButton, pageStyles.listingBackButton]}
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              onClick={() => navigate("/home")}
            >
              Back to Home
            </Button>
          </header>

          <CampaignsPanel
            campaigns={campaigns}
            count={getTotalCount(data, campaigns.length)}
            isLoading={isLoading}
            isError={isError}
            onOpenCampaign={(uuid) =>
              navigate(`/campaigns/${uuid}`, { state: { selCity } })
            }
            bare
          />
        </div>
      </main>
      <Footer1 />
    </div>
  );
};

export default Campaigns;
